// @flow
import { createContext } from 'react';
import type { Context } from 'react';

export const WhiteIpContext: Context<{
  isWhiteIp: boolean,
}> = createContext({
  isWhiteIp: false,
});
